import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Banner from '../../asset/Banner.webp';
import CrossButton from '../../asset/CrossButton.png';
import OffisbayLogo from '../../asset/Offisbay-Logo.png'

export const Header = () => {
  const [showBanner, setShowBanner] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();
  const isperungudi = location.pathname === '/perungudi-chennai' || location.pathname === '/affordable-coworking-space-perungudi' || location.pathname === '/virtual-office-perungudi';


  // Don't show banner on FreeDayPass page
  const shouldShowBanner = showBanner && location.pathname !== '/free-day-pass' && location.pathname !== '/thank-you' && location.pathname !== '/meeting-room';

  const scrollToSection = (target) => {
    const element = document.getElementById(target);
    if (element) {
      const headerHeight = 105;
      const elementPosition = element.offsetTop - headerHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  const scrollToBookATour = () => {
    const element = document.getElementById('book-a-tour');
    if (element) {
      const headerHeight = 105;
      const elementPosition = element.offsetTop - headerHeight;

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div>
      {shouldShowBanner && (
        <div
          className='fixed top-0 left-0 w-[100vw] h-[45px] md:h-[55px] text-white flex items-center justify-between px-2 sm:px-4 md:px-8 z-50 gap-1 sm:gap-4'
          style={{
            backgroundImage: `url(${Banner})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <p className='font-sans text-[8px] sm:text-[14px] md:text-[16px] font-[500] whitespace-nowrap overflow-hidden text-ellipsis'>
            Your seat at just ₹5,999
            <span className='inline sm:hidden'><br /></span>
            <span className='line-through font-[300]'>(₹8,999)</span> {isperungudi ? "in Perungudi" : "in Mount Road!"}
          </p>

          <p className='font-sans text-[13px] sm:text-[16px] md:text-[19px] font-[600] whitespace-nowrap'>
            Financial Year Offer
          </p>

          <div className='flex items-center flex-shrink-0'>
            <button
              onClick={scrollToBookATour}
              className='text-[10px] sm:text-[12px] font-semibold rounded-[30px] px-3 sm:px-5 py-1.5 sm:py-2 bg-white text-[#2B3374] transition-colors'
            >
              Book Now!
            </button>
            <img
              className='w-[16px] sm:w-[20px] h-[16px] sm:h-[20px] ml-2 sm:ml-4 cursor-pointer'
              src={CrossButton}
              alt="Close banner"
              onClick={() => setShowBanner(false)}
            />
          </div>

        </div>

      )}

      <header
        style={{ boxShadow: '0px 5px 8px #ce92a838' }}
        className={`bg-[#ffffff] backdrop-blur-md border-b h-[55px] md:h-[65px] fixed z-[40] right-0 w-full flex items-center justify-between px-6 py-3 md:px-10 transition-all
          ${shouldShowBanner ? 'top-[45px] md:top-[55px]' : 'top-0'}`}
      >
        <div className='flex items-center'>
          <img
            src={OffisbayLogo}
            alt='Offis Bay Logo'
            className='md:h-10 h-8 w-auto cursor-pointer'
            onClick={() => navigate('/')}
          />
        </div>
        <div className='flex'>
          {location.pathname !== '/free-day-pass' && location.pathname !== '/virtual-office-chennai' && location.pathname !== '/virtual-office-perungudi' && location.pathname !== '/thank-you' && window.innerWidth >= 768 && <div className='flex items-center gap-8'>
            <div onClick={() => scrollToSection('amenities')} className='text-[#1D1E1C] text-xs md:text-[14px] cursor-pointer hover:text-[#966376] transition-colors'>
              Amenities
            </div>
            <div onClick={() => navigate(isperungudi ? "/virtual-office-perungudi" : '/virtual-office-chennai')} className='text-[#1D1E1C] text-xs md:text-[14px] cursor-pointer hover:text-[#966376] transition-colors'>
              Virtual Office
            </div>
          </div>}
          <a
            style={{ marginLeft: '2rem' }}
            href="tel:+919876543210"
            className="text-[#1D1E1C] text-xs md:text-[14px] cursor-pointer hover:text-[#966376] transition-colors"
          >
            <span className="flex items-center gap-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
              </svg>
              +91 98765 43210
            </span>
          </a>
        </div>

      </header>
    </div>
  );
};
